<template>
  <div class="orderDetail">
      <div class="banxin">
          <div class="head">
            <router-link to="/orderAfterSale">
                <div class="mar-right-10">售后订单</div>
            </router-link>
            <div class='arrow'></div>
            <div class="mar-right-10" v-if="state==='2'">售后详情</div>
            <div class="mar-right-10" v-if="state==='1'">申请售后</div>
          </div>
          <div class="status">
              <div class="left">
                  <p class="fs16 fw-blod mar-top-20 mar-bot-60" v-if="state==='2'">售后编号：{{orderData.afterFormid}}</p>
                  <p class="fs16 fw-blod mar-top-20 mar-bot-60" v-if="state==='1'">订单号：{{orderData.orderFormid}}</p>
                  <div class="state text-align">
                      <p class="fs24 fw-blod font-color-FF7" v-if="state==='1'">申请售后</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===1">审核中</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===2">退款中</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===3">退货中</p>
                      <p class="fs24 fw-blod font-color-71B" v-if="orderData.afterState===4">退款成功</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===5">退款失败<br><span class="font-color-999">(如有问题，请联系商家)</span></p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===6">审核不通过</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===7">评审中</p>
                      <p class="fs24 fw-blod font-color-999" v-if="orderData.afterState===8">退货完成，拒绝退款</p>
                      <p class="fs24 fw-blod font-color-999" v-if="orderData.afterState===9">已关闭</p>
                      <p class="fs24 fw-blod font-color-FF7" v-if="orderData.afterState===10">审核通过</p>
                      <el-button plain @click="platform" class="intervention mar-top-10" v-if="orderData.afterState===6 || orderData.afterState===8">申请平台介入</el-button>
                      <el-button plain @click="returnRefund" class="intervention mar-top-10" v-if="orderData.afterState===1 && orderData.afterType===1 || orderData.afterState===6 && orderData.afterType===1 || orderData.afterState===10 && orderData.afterType===1">撤销申请</el-button>
                      <el-button plain @click="returnGoods" class="intervention mar-top-10" v-if="orderData.afterState===1 && orderData.afterType===2 || orderData.afterState===6 && orderData.afterType===2">撤销退货</el-button>
                  </div>
              </div>
              <div class="right">
                  <AfterSaleState v-if="state==='1'" :state="''"></AfterSaleState>
                  <AfterSaleState v-else :state="orderData.afterState"></AfterSaleState>
              </div>
          </div>
          <div class="desc">
              <div class="returnAddress" v-if="state!=='1'">
                  <p class="title">退货地址</p>
                  <div class="info">
                      <p>退货地址：{{orderData.returnAdress}}</p>
                      <p>退货收件人：{{orderData.returnPerson}}</p>
                      <p>退货收件人联系电话：{{orderData.returnPhone}}</p>
                  </div>
              </div>
              <div class="storeInfo">
                  <p class="title">卖家信息</p>
                  <div class="info">
                      <p>店铺名称：{{orderData.shopName}}</p>
                      <p>联系电话：{{orderData.chargePersonPhone || orderData.shopPhone}}</p>
                  </div>
              </div>
              <div class="orderInfo">
                  <p class="title">订单信息</p>
                  <div class="info">
                      <p>订单号：{{orderData.orderFormid}}</p>
                      <p>支付渠道：{{orderData.paymentMode}}</p>
                      <p>交易号：{{orderData.transactionId}}</p>
                      <p>创建时间：{{orderData.createTime}}</p>
                      <p>付款时间：{{orderData.paymentTime}}</p>
                      <p v-if="orderData.receiveTime">成交时间：{{orderData.receiveTime}}</p>
                  </div>
              </div>
              <div class="afterSaleInfo" v-if="state!=='1'">
                  <p class="title">售后信息</p>
                  <div class="info">
                      <p>售后方式：{{orderData.afterType==1?'仅退款':'退货退款'}}</p>
                      <p>货物状态：{{orderData.goodsState==0?'未收到货':'已收到货'}}</p>
                      <p>售后理由：{{orderData.returnReason}}</p>
                      <p class="long">退货理由描述：{{orderData.explain}}</p>
                      <div class="pic" v-if="orderData.image">
                          <span>凭证：</span>
                          <el-image
                            v-for="(url,ins) in image"
                            :key="ins"
                            style="width: 100px; height: 100px"
                            :src="url"
                            :preview-src-list="image">
                          </el-image>
                      </div>
                  </div>
              </div>
              <div class="productInfo">
                  <div class="top">
                      <span class="big">商品</span>
                      <span>商品属性</span>
                      <span>状态</span>
                      <span>数量</span>
                      <span>单价</span>
                  </div>
                  <div class="bottom" v-for="(pro, idx) in orderData.skus" :key="idx">
                      <div class="big">
                          <img :src="pro.image" alt="">
                          <p>{{pro.productName}}</p>
                      </div>
                      <div style="flex-direction: column;">
                          <p v-for="(text, ins) in pro.values" :key="ins">{{text}}</p>
                      </div>
                      <div v-if="orderData.state==1 || orderData.orderState==1">待付款</div>
                      <div v-if="orderData.state==2 || orderData.orderState==2">待发货</div>
                      <div v-if="orderData.state==3 || orderData.orderState==3">待收货</div>
                      <div v-if="orderData.state==4 || orderData.orderState==4">已完成</div>
                      <div v-if="orderData.state==5 || orderData.orderState==5">已关闭</div>
                      <div>{{pro.number}}</div>
                      <div class="font-color-FF7 fs-bold">¥{{pro.price}}</div>
                  </div>
              </div>
              <div class="returnPrice" v-if="orderData.afterState===4">
                  <div>
                      <span class="mar-right-40">退款金额：</span>
                      <span class="font-color-FF7">¥{{orderData.price}}</span>
                  </div>
              </div>
              <div class="apply" v-if="state==='1'">
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30"><span class="font-color-FF7">✱</span>售后方式：</div>
                       <el-select v-model="mode" placeholder="请选择售后方式">
                         <el-option
                           v-for="item in modes"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                         </el-option>
                       </el-select>
                  </div>
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30"><span class="font-color-FF7">✱</span>货物状态：</div>
                       <el-select v-model="goodsState" placeholder="请选择货物状态">
                         <el-option
                           v-for="item in goodsStatus"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                         </el-option>
                       </el-select>
                  </div>
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30"><span class="font-color-FF7">✱</span>售后理由：</div>
                       <el-select v-model="reason" placeholder="请选择售后理由">
                         <el-option
                           v-for="item in reasons"
                           :key="item"
                           :label="item"
                           :value="item">
                         </el-option>
                       </el-select>
                  </div>
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30 mar-left-10">原因描述：</div>
                      <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="输入申请退货原因描述"
                        v-model="textarea">
                      </el-input>
                  </div>
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30 mar-left-10">上传凭证：</div>
                      <el-upload
                            :action="action"
                            list-type="picture-card"
                            :limit="5"
                            :on-success="handleSuccess"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                          </el-upload>
                  </div>
                  <div class="submit mar-20">
                      <el-button plain @click="submit" v-throttle>提交申请</el-button>
                  </div>
              </div>
              <div class="express" v-if="orderData.afterState===10">
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30"><span class="font-color-FF7">✱</span>物流公司：</div>
                       <el-select v-model="exp" placeholder="请选择物流公司">
                         <el-option
                           v-for="item in express"
                           :key="item.dictId"
                           :label="item.dictName"
                           :value="item.dictId">
                         </el-option>
                       </el-select>
                  </div>
                  <div class="flex-display mar-bot-10">
                      <div class="mar-right-30"><span class="font-color-FF7">✱</span>物流单号：</div>
                      <el-input
                        style="width:30%;margin-bottom:20px;"
                        type="number"
                        placeholder="请填写物流单号"
                        v-model="text">
                      </el-input>
                  </div>
                  <div style="text-align:center;">
                      <el-button plain @click="returnExpress" v-throttle>确认提交</el-button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import AfterSaleState from '../../components/base/afterSaleState'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
export default {
  mixins: [listSearchMixin],
    components: {
        AfterSaleState
    },
    data () {
        return {
            state: 0,
            orderData: {},
            modes: [{
                value: 1,
                label: '仅退款'
            }, {
                value: 2,
                label: '退货退款'
            }],
            reasons: [],
            goodsStatus: [{
                value: 1,
                label: '已收到货'
            }, {
                value: 0,
                label: '未收到货'
            }],
            express: [],
            exp: '',
            mode: '',
            reason: '',
            goodsState: '',
            textarea: '',
            textarea1: '',
            text: '',
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            skus: [],
            productPrice: 0,
            urls: [],
            orderId: '',
            afterId: '',
            afterSaleDetail: {},
            action: api.upload,
            image: []
        }
    },
    created () {
        // console.log(this.$route.query.orderData)
        this.state = this.$route.query.state
        if (this.$route.query.state === '2') {
            this.orderId = this.$route.query.orderId
            this.afterId = this.$route.query.afterId
        }
    },
    mounted () {
        if (this.state === '1') {
            this.getReasonSelect()
            this.getOrderDetail()
        } else if (this.state === '2' || this.state === '3') {
            this.getAfterSaleDetail()
            this.getExpressSelect()
        }
    },
    methods: {
        // 获取订单详情
        getOrderDetail () {
          const rLoading = this.openLoading()
          let self = this
          let params = {
            url: api.getOrderDetail + '?orderId=' + JSON.parse(self.$route.query.orderData).orderId,
            method: 'GET',
            data: {
            }
          }
          self.sendReq(params, (res) => {
            if (res.code === '200') {
                self.orderData = res.data
                self.orderData.skus = JSON.parse(self.$route.query.orderData).skus
                rLoading.close()
            } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
          })
        },
        // 获取售后订单详情
        getAfterSaleDetail () {
            const rLoading = this.openLoading()
            let self = this
            let params = {
              url: api.getAfterSaleDetail + `?afterId=${this.afterId}&orderId=${this.orderId}`,
              method: 'GET',
              data: {
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  self.orderData = res.data
                  self.image = res.data.image.split(',')
                  rLoading.close()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 选择物流公司查询
        getExpressSelect () {
            let self = this
            let params = {
              url: api.getExpressSelect,
              method: 'GET',
              data: {
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  self.express = res.data
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 录入物流
        returnExpress () {
            let self = this
            if (self.exp === '') {
                self.$message({
                    message: '请选择物流公司',
                    type: 'warning'
                })
                return
            } else if (self.text.length < 8) {
                self.$message({
                    message: '物流单号格式错误',
                    type: 'warning'
                })
                return
            }
            let params = {
              url: api.returnExpress,
              method: 'POST',
              data: {
                  afterId: self.orderData.afterId,
                  orderId: self.orderData.orderId,
                  express: self.exp,
                  deliverFormid: self.text
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  // console.log(res)
                  self.$message({
                      message: '录入物流成功',
                      type: 'success'
                  })
                  self.getAfterSaleDetail()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 撤销申请
        returnRefund () {
            let self = this
            let params = {
              url: api.returnRefund,
              method: 'PUT',
              data: {
                  afterId: self.orderData.afterId,
                  orderId: self.orderData.orderId
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  // console.log(res)
                  self.$message({
                      message: '撤销申请成功',
                      type: 'success'
                  })
                  self.getAfterSaleDetail()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 撤销退货
        returnGoods () {
            let self = this
            let params = {
              url: api.returnGoods,
              method: 'PUT',
              data: {
                  afterId: self.orderData.afterId,
                  orderId: self.orderData.orderId
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  // console.log(res)
                  self.$message({
                      message: '撤销退货成功',
                      type: 'success'
                  })
                  self.getAfterSaleDetail()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 申请平台介入
        platform () {
            let self = this
            let params = {
              url: api.platform,
              method: 'POST',
              data: {
                  afterId: self.orderData.afterId,
                  orderId: self.orderData.orderId,
                  image: '',
                  reason: ''
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  self.$message({
                      message: '申请平台介入成功',
                      type: 'success'
                  })
                  self.getAfterSaleDetail()
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 选择退款原因查询
        getReasonSelect () {
            let self = this
            let params = {
              url: api.getReasonSelect,
              method: 'GET',
              data: {
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  self.reasons = res.data
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 申请售后
        submit () {
            let self = this
            if (self.mode === '') {
                self.$message({
                    message: '请选择售后方式',
                    type: 'warning'
                })
                return
            } else if (self.goodsState === '') {
                self.$message({
                    message: '请选择货物状态',
                    type: 'warning'
                })
                return
            } else if (self.reason === '') {
                self.$message({
                    message: '请选择售后理由',
                    type: 'warning'
                })
                return
            }
            for (var i in self.orderData.skus) {
                self.skus[i] = {number: self.orderData.skus[i].number, skuId: self.orderData.skus[i].skuId}
                self.productPrice += (self.orderData.skus[i].price * self.orderData.skus[i].number)
            }
            let params = {
              url: api.submit,
              method: 'POST',
              data: {
                afterType: self.mode,
                explain: self.textarea,
                goodsState: self.goodsState,
                image: self.urls.join(','),
                orderId: self.orderData.orderId,
                price: self.productPrice,
                returnReason: self.reason,
                skus: self.skus
              }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                  self.$message({
                    message: '售后申请成功',
                    type: 'success'
                  })
                  setTimeout(() => {
                      self.$router.push('/orderAfterSale')
                  }, 1000)
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        handleSuccess (res) {
            this.urls.push(res.data.url)
        },
        handleRemove (file, fileList) {
            this.urls = []
            for (var i in fileList) {
              this.urls.push(fileList[i].response.data.url)
            }
        }
    }
}
</script>
<style lang="scss">
.orderDetail{
    width: 100%;
    .banxin{
        width: 1252px;
        margin: 0 auto;
        .head {
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            display: flex;
            align-items: center;
            .arrow {
                background-image: url('../../../static/image/xiangyou@2x.png');
                width: 5px;
                height: 10px;
                margin-right: 10px;
            }
        }
        .status{
            width: 100%;
            height: 325px;
            border: 1px solid #E5E5E5;
            box-sizing: border-box;
            padding: 15px;
            display: flex;
            margin-bottom: 20px;
            .left{
                flex: 1;
                border-right: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                flex-direction: column;
                position: relative;
                .state{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
                .cancel{
                    width: 100px;
                }
                .intervention{
                    border-color: #FF7800;
                    color: #FF7800;
                    margin-left: 0;
                }
                .intervention:hover{
                    background-color: rgba($color: #FF7800, $alpha: 0.3);
                }
                .box{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }
            .right{
                flex: 3;
                padding: 20px;
                box-sizing: border-box;
            }
        }
        .logistics{
            padding: 25px;
            width: 100%;
            box-sizing: border-box;
            margin-bottom: 20px;
            border: 1px solid #E5E5E5;
            .content{
                display: flex;
                .left{
                    padding: 20px 0;
                    flex: 2;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    border-right: 2px solid #E5E5E5;
                    img{
                        width: 200px;
                        height: 200px;
                        margin-right: 40px;
                    }
                    div{
                        p{
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 20px;
                        }
                    }
                }
                .right{
                    flex: 3;
                    padding: 20px;
                    box-sizing: border-box;
                    display: flex;
                    .dilevery{
                        height: 280px;
                        width: 600px;
                        overflow-x: auto;
                        padding: 20px;
                        box-sizing: border-box;
                        div{
                            padding-left: 25px;
                            margin-bottom: 25px;
                            position: relative;
                            box-sizing: border-box;
                            white-space: nowrap;
                            .dot{
                                // display: inline-block;
                                width: 6px;
                                height: 6px;
                                border-radius: 3px;
                                background-color: #D9D9D9;
                                margin-right: 10px;
                                position: absolute;
                                left: 0;
                                top: 50%;
                                transform: translate(50%,0);
                                .line{
                                    position: absolute;
                                    left: 50%;
                                    top: 12px;
                                    transform: translate(-50%,0);
                                    width: 2px;
                                    height: 25px;
                                    background-color: #F1F1F1;
                                }
                            }
                            // .line{
                            //     width: 100%;
                            //     border-left: 2px solid #F1F1F1;
                            //     height: 25px;
                            //     margin-left: -21px;
                            // }
                        }
                        div:last-child{
                            margin-bottom: 0;
                            .line{
                                display: none;
                            }
                        }
                        .active{
                            .dot{
                                background-color: #FF7800;
                            }
                        }
                    }
                }
            }
        }
        .desc{
            width: 100%;
            border: 1px solid #E5E5E5;
            margin-bottom: 140px;
            .storeInfo,.orderInfo,.returnAddress,.afterSaleInfo{
                padding: 25px;
                border-bottom: 1px solid #E5E5E5;
                .title{
                    font-size: 16px;
                    margin-bottom: 25px;
                }
                .info{
                    display: flex;
                    margin-left: 75px;
                    flex-wrap: wrap;
                    p{
                        line-height: 30px;
                        width: 50%;
                        font-size: 14px;
                        margin-bottom: 10px;
                    }
                    .long{
                        width: 100%;
                    }
                    .pic{
                        margin-top: 10px;
                        width: 100%;
                        font-size: 14px;
                        span{
                            vertical-align: top;
                            margin-right: 10px;
                        }
                        .el-image{
                            img{
                                margin-right: 10px;
                            }
                        }
                    }

                }
            }
            .orderInfo,.returnAddress,.afterSaleInfo{
                .info{
                    p{
                        width: 33.33%;
                    }
                }
            }
            .productInfo{
                width: 100%;
                .top{
                    height: 40px;
                    width: 100%;
                    background-color: #EDEDED;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    span{
                        flex: 1;
                        font-size: 12px;
                    }
                    .big{
                        flex: 2;
                    }
                }
                .bottom{
                    width: 100%;
                    padding: 20px 0;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    div{
                        flex: 1;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        p{
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                    .big{
                        text-align: left;
                        flex: 2;
                        display: flex;
                        box-sizing: border-box;
                        justify-content: flex-start;
                        align-items: center;
                        img{
                            width: 80px;
                            height: 80px;
                            margin: 0 20px;
                        }
                        p{
                            width: 50%;
                        }
                    }
                }
            }
            .settlement{
                width: 100%;
                display: flex;
                padding: 25px;
                box-sizing: border-box;
                justify-content: flex-end;
                .box{
                    display: flex;
                    .left{
                        text-align: right;
                        p{
                            width: 250px;
                            display: flex;
                            justify-content: space-between;
                            font-size: 20px;
                            color: #666666;
                            line-height: 30px;
                        }
                        .right{
                            text-align: right;
                            margin-left: 40px;
                        }
                    }
                }
            }
            .returnPrice{
                width: 100%;
                padding: 50px 50px;
                font-size: 20px;
                box-sizing: border-box;
                text-align: right;
                border-bottom: 1px solid #E5E5E5;
            }
            .apply{
                width: 100%;
                padding: 25px;
                box-sizing: border-box;
                .el-select{
                    margin-bottom: 20px;
                }
                .el-textarea{
                    width: 40%;
                    margin-bottom: 20px;
                    margin-right: 20px;
                }
                .up{
                    display: flex;
                    margin-bottom: 20px;
                }
                .submit{
                    text-align: center;
                    .el-button{
                        width: 150px;
                        background-color: #FF7800;
                        color: #FFFFFF;
                    }
                }
            }
            .express{
                width: 100%;
                padding: 25px;
                box-sizing: border-box;
                .el-select{
                    margin-bottom: 20px;
                }
                .el-button{
                    width: 150px;
                    background-color: #FF7800;
                    color: #FFFFFF;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/afterSale/index.vue